import Sidebar from "../../components/Common/Sidebar";
import PublicationsFramework from "../../components/_pages/Publications/PublicationsFramework";

const Publications = () => {
  return (
    <>
      <Sidebar />
      <PublicationsFramework />
    </>
  );
};

export default Publications;
